export function getChatIdParam() {
  try {
    return new URL(window.location).searchParams.get('chat_id');
  } catch { return null; }
}

export function setChatIdParam(id) {
  const url = new URL(window.location);
  url.searchParams.set('chat_id', id);
  window.history.pushState(null, '', url);
}

export function removeChatIdParam() {
  const url = new URL(window.location);
  url.searchParams.delete('chat_id');
  window.history.replaceState(null, '', url);
}
